
import React from 'react';
import jobData from '../Data/Jobs.json'; // Asegúrate de importar el JSON correctamente
import { JobCard } from '../componets/JobCard';

import { Fotter } from '../componets/Fotter';


export const Experience = () => {
  return (
    <>

    <div className='job' >
      <h1 className='experience'>Job History</h1>
      {jobData.map((job, index) => (
        <JobCard
          key={index}
          position={job.position}
          company={job.company}
          date={job.date}
          description={job.description}
        />
      ))}
    </div>
    <Fotter/>
    </>
  );
};


